import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { translate } from 'react-i18next';
import Constants from '../../config/constants';
import { defaultRejectHandler, getErrorValue, withDefaultSort } from '../../utils/utility';
import Layout from '../../components/layout/Layout';
import Card from '../../components/card/Card';
import DataTable from '../../components/datatable/DataTable';
import Alert from '../../modal/alert/Alert';
import Thumbnail from '../../components/thumbnail/Thumbnail';
import ComponentOpaqueCreateModal from '../../modal/component_opaque/ComponentOpaqueCreateModal';
import ComponentOpaqueEditModal from '../../modal/component_opaque/ComponentOpaqueEditModal';
import OpaqueComponentDuplicateModal from '../../modal/duplicate/OpaqueComponentDuplicateModal';
import { COLUMN_STYLE, getColumnStyle } from '../../components/datatable/util';

import {
  listComponentOpaque,
  deleteComponentOpaque,
  clearErrorComponentOpaque,
} from '../../redux/component_opaque/component_actions';


import {
  clearErrorComponentMaterial,
} from '../../redux/component/component_material_actions';


class ComponentOpaquePage extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: this.DEFAULT_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);

    this.columns = [
      {
        Header: '',
        accessor: 'thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'name',
        ...textColumn,
      },
      {
        Header: () => <b>{t('category')}</b>,
        accessor: 'is_public',
        Cell: row => row.value
            ? <span><i className="fas fa-users"/> {t('public')}</span>
            : <span><i className="fas fa-user"/> {t('private')}</span>,
        ...getColumnStyle(COLUMN_STYLE.category),
      },
      {
        Header: () => <b>{t('outer surface color')}</b>,
        accessor: 'solar_absorptance_name',
        Cell: row => t(Constants.MAPPER.outer_surface_colors[row.value]),
        ...textColumn,
        width: 200,
      },
      {
        Header: () => <b>{t('inner surface')}</b>,
        accessor: 'heat_dissipation_name',
        Cell: row => t(String(row.value).toLowerCase()),
        ...textColumn,
        width: 120,
      },
    ];

    this.state = {
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isShowDuplicateModal: false,
      isCreated: false,
      isEdited: false,
      isDuplicated: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreating && nextProps.isCreating !== this.props.isCreating && !nextProps.errorMessage) {
      this.setState({ isShowCreateModal: false, isCreated: true  });
    }

    if (this.props.isEditing && nextProps.isEditing !== this.props.isEditing && !nextProps.errorMessage) {
      this.setState({ isShowEditModal: false, isEdited: true  });
    }

    if (this.props.isDeleting && nextProps.isDeleting !== this.props.isDeleting && !nextProps.errorMessage) {
      this.setState({ isShowDeleteModal: false });
    }

    if (this.props.isDuplicating && nextProps.isDuplicating !== this.props.isDuplicating && !nextProps.errorMessage) {
      this.setState({ isShowDuplicateModal: false, isDuplicated: true });
    }
  }

  onClickCreateComponent(){
    this.props.clearError();
    this.props.clearMaterialError();
    this.setState({ isShowCreateModal: true, isCreated: false })
  }
  renderActionMenu() {
    return [
      <li>
        <a
          id="component-opaque-create"
          href="#"
          data-toggle="modal"
          data-target="#create-component-opaque"
          onClick={() => this.onClickCreateComponent()}
        >
          <i className="fas fa-plus-square" />
          <span className="menu-text">{this.props.t('create opaque component')}</span>
        </a>
      </li>
    ];
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listComponent(
      this.search.pageSize,
      this.search.page,
      withDefaultSort(this.search.sorted),
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category.value],
    );

    this.setState({ categoryOption: category });
  }

  dismissCreateModal() {
    this.props.clearError();
    this.setState({ isShowCreateModal: false });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  dismissDuplicateModal() {
    this.props.clearError();
    this.setState({ isShowDuplicateModal: false });
  }

  render() {
    const {
      categoryOption,
      selectedComponent: component,
      isShowCreateModal,
      isShowEditModal,
      isShowDeleteModal,
      isShowDuplicateModal,
    } = this.state;

    const {
      filtered,
      filteredCount,
      isLoading,
      isDeleting,
      isDuplicating,
      errorMessage,
      t,
    } = this.props;

    const breadcrumbItems = [
      { name: t('components'), path: '/components' },
      { name: t('opaque component'), path: '/components/opaque' },
    ];

    const helpConfig = {
      title: t('help'),
      contentUrl: '/html/help_opaque_component.html',
    };

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
        renderActionMenu={() => this.renderActionMenu()}
        help={helpConfig}
      >
        <ComponentOpaqueCreateModal
          show={isShowCreateModal}
          isCreated={this.state.isCreated}
          onHide={() => this.dismissCreateModal()}
        />
        <ComponentOpaqueEditModal
          component={component}
          show={isShowEditModal}
          isEdited={this.state.isEdited}
          onHide={() => this.dismissEditModal()}
        />
        <OpaqueComponentDuplicateModal
          item={component}
          show={isShowDuplicateModal}
          title={t('copy opaque component')}
          label={t('new opaque component name')}
          isDuplicated={this.state.isDuplicated}
          onHide={() => !isDuplicating && this.dismissDuplicateModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete component')}
          body={`${t('do you want to delete')} ${component ? component.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? t('deleting') : t('delete')}
          primaryButtonStyle={'danger'}
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteComponent(component)}
        />
        <h1>{t('opaque component')}</h1>
        <Card padding={false}>
          <div className="filter-box" style={{ display: 'flex', padding: 20, marginBottom: 20 }}>
            <input
              id="component-opaque-search-name"
              className="text-search"
              style={{ width: 240, height: 36, margin: 10 }}
              type="text"
              onChange={event => this.updateSortFilter(event.target.value, null, categoryOption)}
              placeholder={t('search name')}
            />
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              style={{
                control: () => ({
                  width: 200,
                }),
              }}
              value={categoryOption}
              placeholder={t('category')}
              onChange={option => this.updateSortFilter(filtered, null, option)}
              options={[
                { value: 'all', label: t('all') },
                { value: 'public', label: t('public') },
                { value: 'private', label: t('private') },
              ]}
            />
          </div>
          <DataTable
            columns={this.columns}
            data={this.props.components}
            onActionEdit={item => this.setState({ isShowEditModal: true, selectedComponent: item.original, isEdited: false })}
            onActionDuplicate={item => this.setState({ isShowDuplicateModal: true, selectedComponent: item.original, isDuplicated: false })}
            onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedComponent: item.original })}
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
          />
        </Card>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  components: state.component.opaque.orderedIds.map(id => state.component.opaque.components[id]),
  filteredCount: state.component.opaque.filteredCount,
  isLoading: state.component.opaque.isLoading,
  isCreating: state.component.opaque.isCreating,
  isEditing: state.component.opaque.isEditing,
  isDeleting: state.component.opaque.isDeleting,
  isDuplicating: state.component.opaque.isDuplicating,
  errorMessage: state.component.opaque.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  listComponent: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(
      dispatch(listComponentOpaque(pageSize, page, sorted, filtered, isPublic))
    ),
  deleteComponent: component => defaultRejectHandler(dispatch(deleteComponentOpaque(component.id))),
  clearError: () => dispatch(clearErrorComponentOpaque()),
  clearMaterialError: () => dispatch(clearErrorComponentMaterial()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ComponentOpaquePage),
);



// WEBPACK FOOTER //
// ./src/pages/component_opaque/ComponentOpaquePage.js